import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import CatalogView from "../components/CatalogView";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Catalogo premi digitale pubblico: /scopri/catalogo/:slug (+ PDF stampabile)
export default function CatalogPage() {
  const { slug } = useParams();
  const [d, setD] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => { axios.get(`${API}/public/catalogs/${slug}`).then((r) => setD(r.data)).catch(() => setErr(true)); }, [slug]);
  if (err) return <main className="min-h-screen bg-zinc-100 p-6 text-center text-zinc-700" data-testid="catalog-not-found">Catalogo non disponibile.</main>;
  if (!d) return <main className="min-h-screen bg-zinc-100 p-6 animate-pulse" data-testid="catalog-loading"><div className="mx-auto max-w-3xl h-64 rounded-3xl bg-zinc-300" /></main>;
  const t = localStorage.getItem("kl_tenant");
  return <CatalogView d={d} pdfUrl={`${API}/public/catalogs/${d.slug}.pdf${t ? `?t=${t}` : ""}`}
    backLink={<Link to="/scopri" className="text-xs opacity-80 hover:underline" data-testid="catalog-back">← Torna alla pagina del circuito</Link>} />;
}
